import React from 'react';
import { Carousel } from 'react-bootstrap';

// Import images from assets
import slide1 from '../assets/images/slide2.jpeg';
import slide2 from '../assets/images/slide1.jpg';
import './Home.css';
const Home = () => (
  <section id="home" className="mt-5 pt-5">
    <Carousel>
      <Carousel.Item>
        <img className="d-block w-100" src={slide2} alt="Slide 2" />
        <Carousel.Caption>
          <h3>Reliable & On-Time Delivery</h3>
          <p>Your trusted industrial coating partner.</p>
        </Carousel.Caption>
      </Carousel.Item>
      
      <Carousel.Item>
        <img className="d-block w-100" src={slide1} alt="Slide 1" />
        <Carousel.Caption>
          <h3>High-Quality Powder Coating</h3>
          <p>Durable and beautiful finishes for all metal parts.</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  </section>
);

export default Home;
